import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { DatePicker } from '@components/ui/form/date';
import { shortDate, shortDay } from '@utils/i18n';
import { SchedulerDateProps } from './types';
import { addDays, subDays } from 'date-fns';
import { cn } from '@utils/cn';

export const SchedulerDate = ({
  date,
  setDate,
  className,
  calendar,
  loading,
}: SchedulerDateProps) => (
  <div className={cn('flex items-center gap-1', className)}>
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        className="p-1"
        disabled={loading}
        onClick={() => setDate(subDays(date, 1))}>
        <SvgConsumer id="arrow" className="-scale-x-100" />
      </Button>
      <strong className="flex w-32 select-none items-center justify-center whitespace-nowrap text-heading-xs">
        {shortDay(date)}, {shortDate(date)}
      </strong>
      <Button
        variant="ghost"
        className="p-1"
        disabled={loading}
        onClick={() => setDate(addDays(date, 1))}>
        <SvgConsumer id="arrow" />
      </Button>
    </div>
    <DatePicker
      mode="single"
      noText
      noRemove
      className="h-fit w-fit border-0 p-1 text-inherit"
      value={date}
      open={calendar?.open}
      setOpen={calendar?.setOpen}
      modifiers={calendar?.modifiers}
      modifiersClassNames={calendar?.modifiersClassNames}
      legend={calendar?.legend}
      todayDisabled={loading}
      onChange={(value) => {
        if (!value) return;
        setDate(value);
      }}
    />
  </div>
);
